export type SupportedLanguage = 'en' | 'pt-BR';

export interface LanguageOption {
  code: SupportedLanguage;
  label: string;
  nativeLabel: string;
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'pt-BR', label: 'Portuguese (Brazil)', nativeLabel: 'Portugu\u00eas (Brasil)' },
];

export const LANGUAGE_STORAGE_KEY = 'gs-preferred-language';

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

export function resolveLanguage(stored: string | null): SupportedLanguage {
  const valid = SUPPORTED_LANGUAGES.some((l) => l.code === stored);
  return valid ? (stored as SupportedLanguage) : DEFAULT_LANGUAGE;
}
